import React, { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Page_settings } from '../../config/page_settings'
import { observer } from 'mobx-react'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import { FORMAT, MaleUrl } from '../../config/const'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import strings from '../../lang/strings'
import { rootStore } from '../../mobx/store'
import ItemWineeBanner from '../../components/item/item_banner_winee'
import ItemCategory from '../../components/item/item_category'
import { string, fphoto } from '../../helper/common'
import PopupModal from '../../components/control/modal/modal_popup'
import moment from 'moment'
import RankDashboard from '../../components/rank/rank_dashboard'

const Dashboard = observer((props) => {
  const context = useContext(Page_settings)
  let [bannerList, setBannerList] = useState([])
  let [continueList, setContinueList] = useState([])
  let [hitrateList, setHitrateList] = useState([])
  let [profitList, setProfitList] = useState([])
  // let [topWeekList, setTopWeekList] = useState([])
  let [bjList, setBjList] = useState([])
  let [wineeAnalystList, setWineeAnalystList] = useState([])
  let [category1, setCategory1] = useState(0)
  // let [category2, setCategory2] = useState(0)
  // let [topTitle, setTopTitle] = useState('')
  let [bannerMove, setBannerMove] = useState(false)
  let [topIdx, setTopIdx] = useState(0)
  // let [topMove, setTopMove] = useState(false)
  let [bjMove, setBjMove] = useState(false)
  // let [wineeMove, setWineeMove] = useState(false)
  let [showPopup, setShowPopup] = useState(false)
  let [popupInfo, setPopupInfo] = useState(Object)

  const [autoPlay, setAutoPlay] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(1);

  const updateItemsToShow = () => {
    const width = window.innerWidth;
    if (width >= 760) {
      setItemsToShow(2);
    } else {
      setItemsToShow(1);
    }
  };

  // const category = [strings.straight_rank, strings.hit, strings.share_rate, strings.sale_amount]
  const category = [strings.straight_rank, strings.hit_rank]

  useEffect(() => {
    //init()
    getInfo()
    updateItemsToShow(); // 아이템 수 초기화
    window.addEventListener('resize', updateItemsToShow);
    getTopList(0, 0);
    getTopList(0, 1);
    getTopList(0, 2);
    return () => {
      window.removeEventListener('resize', updateItemsToShow); // 리스너 제거
    };
  }, [])

  useEffect(() => {
    setAutoPlay(itemsToShow < bannerList.length);
  }, [itemsToShow, bannerList]);


  // useEffect(() => {
  //   getTopList(0, category1)
  // }, [category1])

  // useEffect(() => {
  //   getTopList(1, category2)
  // }, [category2])

  const init = () => {
    let id = localStorage.getItem('id') ?? ''
    let pwd = localStorage.getItem('pwd') ?? ''
    let sns_id = localStorage.getItem('sns_id') ?? ''
    let loginType = localStorage.getItem('loginType') ?? 0
    let autoLogin = localStorage.getItem('autoLogin') ?? 0
    if (autoLogin == 1 && ((loginType == 1 && id !== '' && pwd !== '') || (loginType > 1 && sns_id !== '')) && !rootStore.isSignedIn) {
      context.post('member/signin', { type: loginType, id: id, pwd: pwd, sns_id: sns_id },
        response => {
          if (response.member) {
            let mb = response.member
            mb.pwd = pwd
            context.login(mb, response.favBj, response.favWinee)
          }
        }
      )
    }

    getInfo()
  }

  const getInfo = () => {
    context.post('main/get_info', {},
      (response) => {
        setBannerList(response.banner)
        // setWineeAnalystList(response.winee)
        setBjList(response.bj)
        if (response.popup != null) {
          setPopupInfo(response.popup)
          let popup_date = localStorage.getItem('popup_date')
          let today = moment(this).format(FORMAT.DATE)
          if (!popup_date || moment(today).isSameOrAfter(moment(popup_date))) {
            setShowPopup(true)
          }

        }
        if (rootStore.isSignedIn) {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          rootStore.signIn(mb)
        }
      }
    )
  }

  const getTopList = (type, sort) => {
    context.post('main/get_top', { type: type, sort: sort },
      (response) => {
        let list = response.list;
        if (sort == 0) {
          setContinueList(list);
        } else if (sort == 1) {
          setHitrateList(list);
        } else if (sort == 2) {
          setProfitList(list);
        }
      }
    )
  }

  const onLinkBanner = (e, item) => {
    if (bannerMove || item.bn_url === '') {
      e.preventDefault()
    }
  }

  const onDetail = (item, move) => {
    if (move) return
    if (item.mb_lv < 4) {
      context.post('data/an_list', { an_id: item.mb_id },
        response => {
          const mb = response.an
          if (mb != null) props.history.push('/analyst/detail', { info: mb, wineeList: response.winee_list })
        }
      )
    } else {
      context.post('data/bj_list', { bj_id: item.mb_id },
        response => {
          const mb = response.bj
          if (mb != null) props.history.push(`/bj/detail/${mb.mb_id}`, { bjList: response.bj_list })
        }
      )
    }
  }

  const onDetailBj = (item) => {
    if (item.mb_lv < 4) {
      context.post('data/an_list', { an_id: item.mb_id },
        response => {
          const mb = response.an
          if (mb != null) props.history.push('/analyst/detail', { info: mb, wineeList: response.winee_list })
        }
      )
    } else {
      context.post('data/bj_list', { bj_id: item.mb_id },
        response => {
          const mb = response.bj
          if (mb != null) props.history.push(`/bj/detail/${mb.mb_id}`, { bjList: response.bj_list })
        }
      )
    }
  }

  const CustomDot = ({ onClick, ...rest }) => {
    const { active } = rest
    return (
      <div className={active ? 'active' : 'inactive'} onClick={() => onClick()} />
    )
  }

  const ButtonGroup = ({ next, previous, type }) => {
    return (
      <div className='carousel-button-group w-100 d-center ph-10 sm-ph-5'>
        <div className='fs-24 sm-fs-20 f-b flex-full'>{type === 0 ? strings.bj : strings.analyst_winee}</div>
        <img className={'a3_l'} src={'/assets/image/a3_l.png'} alt={''} onClick={() => previous()} />
        <img className={'a3_l ml-10'} src={'/assets/image/a3_r.png'} alt={''} onClick={() => next()} />
      </div>
    )
  }

  const ButtonGroup1 = ({ next, previous }) => {
    return (
      <div className='top_banner_group w-100 d-center'>
        <img className={'a2_l ml-18 sm-ml-12'} src={'/assets/image/a2_l.png'} alt={''} onClick={() => previous()} />
        <div className={'flex-full'} />
        <img className={'a2_l mr-15 sm-mr-12'} src={'/assets/image/a2_r.png'} alt={''} onClick={() => next()} />
      </div>
    )
  }

  const isCurrentHostURL = (url) => {
    // http* 로 시작하지 않는 정상적인 url아 아니면 상대경로로 판단
    try { new URL(url); } catch (e) { return true; }

    // http*로 시작하면 host이름 비교
    const currentHost = window.location.host;
    try {
      const parsedURL = new URL(url);
      return parsedURL.host === currentHost; // 현재 호스트와 비교
    } catch (e) {

    }
    return false;
  }

  return (
    <React.Fragment>
      <div className='dashboard-top-area'>
        <div style={{ margin: '0 auto', position: 'relative', width: '50%', minWidth: '900px', maxWidth : '1440px' }}>
          <img src={'/assets/image/dashboard-main.webp'}></img>
          <div className='this-is-winee-container'>
            <div className='this-is-winee'>
              <img src={'/assets/image/ic-winee.png'} style={{ width: '143px', marginBottom: '11px' }}></img>
              <div>오늘을 이기는 선택</div>
            </div>
          </div>
        </div>
      </div>

      <div className='content-container sm-ph-0 sm-pv-0'>
        <SidebarLeft history={props.history} />
        <div className='im-container sm-pt-0'>
          <Carousel additionalTransfrom={0}
            showDots={false} // 임시 처리
            autoPlay={autoPlay} // 임시 처리
            customDot={<CustomDot />}
            arrows={false}
            draggable={true}
            swipeable={true}
            infinite={true}
            autoPlaySpeed={5000}
            afterChange={() => { setBannerMove(false) }}
            beforeChange={() => { setBannerMove(true) }}
            containerClass={'pb-28 sm-pb-22'}
            itemClass={'dashboard-banner-ph'}
            responsive={
              {
                superLargeDesktop: {
                  breakpoint: { max: 4000, min: 3000 },
                  items: 2,
                  slidesToSlide: 2,
                },
                desktop: {
                  breakpoint: { max: 3000, min: 1024 },
                  items: 2,
                  slidesToSlide: 2,
                },
                tablet: {
                  breakpoint: { max: 1024, min: 464 },
                  items: 2,
                  slidesToSlide: 2,
                },
                mobile: {
                  breakpoint: { max: 760, min: 0 },
                  items: 1,
                  slidesToSlide: 1,
                },
              }
            }>
            {bannerList.map(function (item, idx) {
              return <a key={idx} href={item.bn_url} target={isCurrentHostURL(item.bn_url) ? '' : '_blank'} onClick={(e) => { onLinkBanner(e, item) }} ><img src={fphoto(item.bn_photo, 'banner')} className='banner_img' alt={''} /></a>
            })}
          </Carousel>

          <div className='mt-2 sm-mt-0'>
            <Carousel additionalTransfrom={0}
              arrows={false}
              customButtonGroup={<ButtonGroup type={0} />}
              draggable={true}
              swipeable={true}
              afterChange={() => { setBjMove(false) }}
              beforeChange={() => { setBjMove(true) }}
              containerClass={'pt-76 sm-pt-66 sm-ph-0 sm-mh-10 pb-1'}
              itemClass={'ph-10 sm-ph-5'}
              responsive={
                {
                  superLargeDesktop: {
                    breakpoint: { max: 4000, min: 3000 },
                    items: 4,
                  },
                  desktop: {
                    breakpoint: { max: 3000, min: 1024 },
                    items: 4,
                  },
                  tablet: {
                    breakpoint: { max: 1024, min: 464 },
                    items: 4,
                  },
                  mobile: {
                    breakpoint: { max: 464, min: 0 },
                    items: 2.4,
                  },
                }
              }>
              {Array.from({ length: Math.ceil(bjList.length / 2) }).map((_, idx) => {
                let items = bjList.slice(idx * 2, idx * 2 + 2);
                return (
                  <div className={'dashboard-banner'} key={idx}>
                    {items.map((item, itemIdx) => (
                      <ItemWineeBanner key={itemIdx} item={item} onDetail={() => onDetail(item, bjMove)} />
                    ))}
                  </div>
                );
              })}
            </Carousel>
          </div>

          <div className='divider1 mt-40 mb-20' />
          { (continueList.length > 0 || hitrateList > 0 || profitList > 0 || true) && 
          <div className='flex-full ph-10 sm-ph-15 mb-20 sm-mb-0'>
            <div className='fs-24 sm-fs-20 f-b flex-full hover-underline cursor-point' onClick={ () => { props.history.push(`/winee?tab=special`)}} >
              {strings.dashboard_top5} 
              <span className='fs-14 sm-fs-12 ml-12 color-4c4c4d'>{strings.dashboard_go_special}</span>
              </div>
            {/* <div className='container-category d-flex mt-10 sm-mt-14'>
              {
                category.map((it, idx) => {
                  return (
                    <ItemCategory key={idx} selected={idx === category1} item={it} onSelect={() => {setCategory1(idx)}}/>
                  )
                })
              }
            </div> */}
            <div className='dashboard-rank-container'>
              {continueList.length > 0 && <RankDashboard title={strings.straight_rank} items={continueList} onClick={onDetailBj} />}
                {hitrateList.length > 0 && <RankDashboard title={strings.hit_rank} items={hitrateList} onClick={onDetailBj} />}
                {profitList.length > 0 && <RankDashboard title={strings.profit_rank} items={profitList} onClick={onDetailBj} />}
            </div>
          </div>
}
          <PopupModal show={showPopup} toggle={() => { setShowPopup(!showPopup) }} image={popupInfo.bn_photo} link={popupInfo.bn_url} title={popupInfo.bn_title} />
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(Dashboard)
